import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Command: IconNode = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3' }]],
];

export default Command;
